export interface OtpBox {
  char: string | undefined;
  /** Where the next digit goes: the first empty box, or the last one once the code is complete. */
  active: boolean;
}

/** The boxes shown over the real input, one per digit of the code. */
export function otpBoxes(value: string, length: number): OtpBox[] {
  const typing = value.length < length;
  const complete = value.length === length;
  return Array.from({ length }, (_, i) => ({
    char: value[i],
    active: typing ? i === value.length : complete && i === length - 1,
  }));
}

/** Keeps the digits of what was typed or pasted, up to the code's length. */
export function onlyDigits(text: string, length: number): string {
  return text.replace(/\D/g, "").slice(0, length);
}
